import { render, staticRenderFns } from "./land-video.vue?vue&type=template&id=59b11490"
import script from "./land-video.vue?vue&type=script&lang=js"
export * from "./land-video.vue?vue&type=script&lang=js"
import style0 from "./land-video.vue?vue&type=style&index=0&id=59b11490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports